import Splide from "@splidejs/splide";

document.querySelector("#copy-link-btn").addEventListener("click", (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(window.currentUrl);
});

if (matchMedia("(max-width: 768px)").matches) {
    const breadcrumbs = document.querySelectorAll('nav[aria-label="breadcrumb"] .breadcrumb-item');
    if (breadcrumbs.length > 3) {
        breadcrumbs.forEach((item, i) => {
            if (breadcrumbs.length - 1 === i) {
                item.style.display = 'none';
            }
        });
    }
}

function initSlides() {
    new Splide('.reviews-splide', {
        perPage: 3,
        perMove: 1,
        loop: true,
        pagination: false,
        rewind: true,
        arrows: true,
        autoplay: true,
        arrowPath: "",
        interval: 10000,
        breakpoints: {
            900: {
                perPage: 1,
                perMove: 1,
                arrows: false,
                pagination: true
            },
        },
    }).mount();
}

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlides();
                observer.disconnect();
            }
        });
    });
    observer.observe(document.querySelector('.block-cmc-advert-page-trustpilot'));
} else {
    initSlides();
}
